import React from 'react'

const Footer = () =>(
    <footer className="border">
        <div className="p-3 text-center">
            <p className="text-muted m-0">© 2020 Copyright: PixaBay JE</p>
        </div>
    </footer>
)

export default Footer